<template>
  <v-card class="tab-card bg-dot-img">
    <v-tabs v-model="tab">
     <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1" class="tabs-box" >
          Life Insurance
      </v-tab>

      <v-tab href="#tab-2" class="tabs-box">
          Health Insurance
      </v-tab>

      <v-tab href="#tab-3" class="tabs-box">
          Property Insurance
      </v-tab>

      <v-tab href="#tab-4" class="tabs-box" >
         Vehicle Insurance
      </v-tab>

      <v-tab href="#tab-5" class="tabs-box">
         Travel Insurance
      </v-tab>

      <v-tab href="#tab-6" class="tabs-box">
         Group Insurance
      </v-tab>

      <v-tab href="#tab-7" class="tabs-box">
         Accidental Insurance
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="tabs-content">
      <v-tab-item value="tab-1">
        <Life />
      </v-tab-item>
      <v-tab-item value="tab-2">
        <Health />
      </v-tab-item>
      <v-tab-item value="tab-3">
        <Property />
      </v-tab-item>
      <v-tab-item value="tab-4">
        <Vehicle />
      </v-tab-item>
      <v-tab-item value="tab-5">
        <Travel />
      </v-tab-item>
      <v-tab-item value="tab-6">
        <Group />
      </v-tab-item>
      <v-tab-item value="tab-7">
        <Accidental />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>

  import Life from './LifeInsurance/ListLife'; 
  import Health from './HealthInsurance/ListHealth'; 
  import Property from './PropertyInsurance/ListProperty'; 
  import Vehicle from './VehicleInsurance/ListVehicle'; 
  import Travel from './TravelInsurance/ListTravel'; 
  import Group from './GroupInsurance/ListGroup'; 
  import Accidental from './AccidentalInsurance/ListAccidental'; 
   
  export default {
   components: {
    Life,
    Health,
    Property,
    Vehicle,
    Travel,
    Group,
    Accidental,
    },
    data () {
      return {
        tab: this.$route.params.tab,
        text: '',
        tabName: '',
      }
    },
    beforeCreate(){
    },
    methods:{
      CheckTab(tabName)
      {
        //this.tabName = tabName;;
      }
    },
  }
</script>